<template>
  <ListView
    modelName="SKU"
    perm="master.menu_sku"
    :items.sync="items"
    :params.sync="params"
    title="menu_sku"
    :key="$route.fullPath"
    :sortOptions="sortOptions"
    ref="mainList"
    :tabs="['基本情報']"
    gridKey="SKU"
    :gridCaptions="['状態','ワークフロー',  '商品', 'コード', '名称', '型番', 'バーコード種類', '商品バーコード','補充基準数量',   '初回保存日', '初回保存者 ', '最終更新日', '最終更新者']"
    :gridWidths="[100, 180, 150, 150, 150, 150, 200, 150,150, 150, 150, 150,150]"
    :onCreate="onCreate"
    :importQuery="importQuery"
    :exportQuery="exportQuery"
    :comparer="(a,b)=>a.id == b.id"        
    tooltip="商品のSKU(カラー・サイズなど)を登録します。商品バーコードを指定すると出荷指示書・ピッキングリスト・棚卸指示書にバーコードを表示させることができます。"
    :popup="popup"  
  >
    <!-- 明細項目の配置 -->
    <GridItem slot="grid0" slot-scope="{ item }"><Badge :value="item.state" list="masterBaseStatus"/></GridItem>
    <GridItem slot="grid1" slot-scope="{ item, index }"><Workflow :item="item" :index="index" @updated="onWorkflow" :perm="$refs.mainList.perm+'.approve'"/></GridItem>    
    <!-- <GridItem slot="grid2" slot-scope="{ item }">{{ item.commodityId | commodityCode }}</GridItem> -->
    <GridItem slot="grid2" slot-scope="{ item }">{{ item.commodity.name }}</GridItem>
    <GridItem slot="grid3" slot-scope="{ item }">{{ item.code }}</GridItem>
    <GridItem slot="grid4" slot-scope="{ item, index, listView}" :func="true" @click="listView.onOpenDialogByIndex(index)">{{ item.name }}</GridItem>
    <GridItem slot="grid5" slot-scope="{ item }">{{ item.model }}</GridItem>
    <GridItem slot="grid6" slot-scope="{ item }">{{ item.barcodeType | barcodeTypes }}</GridItem>
    <GridItem slot="grid7" slot-scope="{ item }">{{ item.barcode }}</GridItem>
    <GridItem slot="grid8" slot-scope="{ item }">{{ item.minimumStockQuantity }}</GridItem>    
    <GridItem slot="grid9" slot-scope="{ item }">{{ item.initialSavedOn | timestamp }}</GridItem>
    <GridItem slot="grid10" slot-scope="{ item }">{{ item.initialSavedBy | user }}</GridItem>
    <GridItem slot="grid11" slot-scope="{ item }">{{ item.lastUpdatedOn | timestamp }}</GridItem>
    <GridItem slot="grid12" slot-scope="{ item }">{{ item.lastUpdatedBy | user }}</GridItem>
    <!-- リストメニューの配置 -->
    <template slot="menu" slot-scope="{ listView }">
      <ListViewMenuBar :listView="listView">
        <ListViewMenu slot="file_layout_download" icon="file_download" title="インポートファイル"  @click="$api.fileDownload('https://s-flow.net/downloads/%E3%82%B5%E3%83%9D%E3%83%BC%E3%83%88%E3%82%B5%E3%82%A4%E3%83%88%E8%B3%87%E6%96%99/%E3%83%95%E3%82%A1%E3%82%A4%E3%83%AB%E5%85%A5%E5%87%BA%E5%8A%9B/SKU%E3%83%9E%E3%82%B9%E3%82%BF%E3%82%A4%E3%83%B3%E3%83%9D%E3%83%BC%E3%83%88%E3%83%95%E3%82%A1%E3%82%A4%E3%83%AB.xlsx')" tooltip="SKU情報インポート用のレイアウトファイルをダウンロードします。" />
      </ListViewMenuBar>
    </template>
    <!-- 検索パネルーの配置 -->
    <template slot="search" slot-scope="{ params, handler, listView }">
      <Search :listView="listView">
        <!-- <FilterBox title="商品コード" :value.sync="params.commodityCode" @click="handler" /> -->
        <!-- <FilterBox title="商品名称" :value.sync="params.commodityName" @click="handler" /> -->
        <FilterBox title="コード" :value.sync="params.code" @click="handler" />        
        <FilterBox title="名称" :value.sync="params.name" @click="handler" />        
        <FilterBox title="商品バーコード" :value.sync="params.barcode" @click="handler" />
        <AtcCommodity title="商品" :value.sync="params.commodity" @changed="handler" />        
        <Calendar title="初回保存日(From)" :value.sync="params.initialSavedOnFrom" :deletable="true" @changed="handler" />
        <Calendar title="初回保存日(To)" :value.sync="params.initialSavedOnTo" :deletable="true" @changed="handler" />
        <Calendar title="最終更新日(From)" :value.sync="params.lastUpdatedOnFrom" :deletable="true" @changed="handler" />
        <Calendar title="最終更新日(To)" :value.sync="params.lastUpdatedOnTo" :deletable="true" @changed="handler" />
        <!-- <ComboBox title="所有者" :value.sync="params.holder" list="user" @changed="handler" /> -->
        <AutoComplete title="所有者" :value.sync="params.holder" list="user" @changed="handler" />             
        <ComboBox title="状態" :value.sync="params.state" list="masterBaseStatus" @changed="handler" />        
    </Search>
    </template>
    <!-- エディタの配置 -->
    <template slot="sideEditor" slot-scope="{ listView }">
      <!-- 基本情報タブ -->
      <Editor :item="listView.selected" :owner="listView" :tabs="['基本情報','ワークフロー','更新履歴']" :tabTooltips="[null,null,null]">
        <template slot="tab0" slot-scope="{ editor, item }">
          <EditPanel>
            <!-- 基本情報タブ 左側 -->
            <template slot="left">
              <AtcCommodity title="商品" :value.sync="item.commodity" :editor="editor" :required="true" :enabled="listView.isInsertMode && popup ==null" :linkOnNewTab="false" tooltip="SKUを登録する商品を選択します。【商品一覧】に登録してあるデータの中から選択できます。<br>※1度保存すると変更できません。" />
              <TextBox title="コード" :value.sync="item.code" :editor="editor" :required="true" :enabled="listView.isInsertMode" length="10" tooltip="任意のSKUのコードを登録します。1つの商品に対して、既に【SKU一覧】で使用されているコードは登録できません。<br>※1度保存すると変更できません。" />
              <TextBox title="名称" :value.sync="item.name" :editor="editor" :required="true" length="50" tooltip="最大50文字までの、登録するSKUの名称を設定します。" />
              <TextBox title="型番" :value.sync="item.model" :editor="editor" length="100" tooltip="SKUの型番の情報を入力でき、値は帳票に利用できます。" />
              <ComboBox title="バーコード種類" :value.sync="item.barcodeType" :editor="editor" list="barcodeTypes" :nullValue="0" :isDirectEditEnabled="false" tooltip="登録するSKUに対応するバーコードの種類が選択できます。" />
              <TextBox title="商品バーコード" :value.sync="item.barcode" :editor="editor" :required="isRequiredBarcode(item.barcodeType)" length="25" :isDirectEditEnabled="false" tooltip="登録するSKUのバーコード番号を登録する事ができます。" />
              <NumericBox title="補充基準数量" :value.sync="item.minimumStockQuantity" :editor="editor" :enabled="item.commodity!=null && item.commodity.isNoStock==false" :required="item.replenishmentQuantity>0" :isDirectEditEnabled="false" decimals="3" min="0" max="99999999.999" tooltip="補充する時に基準となる数値を登録します。管理帳票の【補充商品一覧表】の要補充数量算出用に利用されます。" />
              <NumericBox title="補充数量" :value.sync="item.replenishmentQuantity" :editor="editor" :enabled="item.commodity!=null && item.commodity.isNoStock==false" :isDirectEditEnabled="false" :required="item.replenishmentQuantity>0" decimals="3" min="0" max="99999999.999" tooltip="補充が必要な商品を発注する際の数値を入力できます。予定在庫一覧から発注する際の発注数量の初期値として利用されます。" />
              <AtcConversion title="補充単位" :value.sync="item.replenishmentUom2" :editor="editor" :enabled="item.commodity!=null && item.commodity.isNoStock==false" :isDirectEditEnabled="false" :required="item.replenishmentQuantity>0" :commodity="item.commodity" tooltip="補充数量の単位を設定できます。商品の計上単位もしくは荷姿を設定できます。予定在庫一覧から発注する際の単位の初期値として利用されます。"/>
            </template>
            <!-- 基本情報タブ 右側 -->
            <template slot="right">
              <!-- <CheckBox title="EC連携先" :value.sync="item.ecFlag2" list="ecFlags" :isDirectEditEnabled="false" :editor="editor"  tooltip="EC連携先をチェックします。"    />     -->
              <!-- <TextBox title="ベイス種類ID" :value.sync="item.ecBaseId" :length="30" :required="(item.ecFlag & ecFlags.Base)>0" :enabled="(item.ecFlag & ecFlags.Base)>0"   :editor="editor"  tooltip="ベイスの種類IDを指定します。" />                  -->
              <!-- <TextBox title="初回保存日" :value="item.initialSavedOn | timestamp" :editor="editor" :enabled="false" />
              <TextBox title="初回保存者" :value="item.initialSavedBy | user" :editor="editor" :enabled="false" />
              <TextBox title="最終更新日" :value="item.lastUpdatedOn | timestamp" :editor="editor" :enabled="false" />
              <TextBox title="最終更新者" :value="item.lastUpdatedBy | user" :editor="editor" :enabled="false" /> -->
              <!-- <ComboBox title="ワークフロー" :value.sync="item.workflowId" :editor="editor" list="workflow_masterBase" :required="workflowRequired(item)" :enabled="workflowRequired(item)" :nullValue="0" />              
              <TextBox title="所有者" :value="item.holder | user" :editor="editor" :enabled="false" />                
              <TextBox title="状態" :value="item.state | masterBaseStatus" :editor="editor" :enabled="false" />             -->
              <TextBox title="最終更新日" :value="$api.perms.getLastUpdateLabel(item)" :enabled="false" tooltip="選択したSKUデータを最後に更新した日時が表示されます。" />
              <ComboBox title="ワークフロー" :value.sync="item.workflowId" :editor="editor" list="workflow_masterBase" :required="$api.perms.hasWorkflow('masterBase')" :enabled="$api.perms.hasWorkflow('masterBase') && $api.perms.isEntryStatus(item)" :nullValue="0" tooltip="マスタ登録用のワークフローを指定します。【フロー区分】が【マスタ管理】になっているデータから選択ができます。" />
              <TextBox title="状態" :value="$api.perms.getWorkflowStateLabel(item)" :enabled="false" tooltip="SKUデータの現在の状態が表示されており､ワークフロー欄の確定や使用停止ボタンをクリックすることで変化します。" />
            </template>
          </EditPanel>
        </template>
        <!-- ワークフロータブ -->
        <template slot="tab1" slot-scope="{ item, editor }">
          <MessageList class="cx_matter_message" :item="item" :editor="editor" />
        </template>
        <!-- 更新履歴タブ -->
        <template slot="tab2" slot-scope="{ item }">
          <AuditLog :auditName="item.auditName" :auditNo="item.auditNo" />
        </template>
      </Editor>
    </template>
  </ListView>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class SKUView extends Vue {
  public items: Common.SKU[] = new Array(0);
  public params: Common.SKUQuery = new Common.SKUQuery();
  public importQuery = new Common.ImportQuery('SKU','SKU');
  public exportQuery = new Common.ExportQuery('SKU', this.params);
  @Prop() public auditNo:string;
  @Prop() public commodity:Common.Commodity;
  @Prop({default:null}) public popup: Components.PopupEditor;  

  public ecFlags = Common.ECFlags;
  
  public sortOptions: any = [
    { value: 'State', text:'状態' },
    { value: 'commodity', text: '商品'},
    { value: 'code', text: 'コード' },
    { value: 'name', text: '名称' },
    { value: 'model', text: '型番' },
    { value: 'initialSavedOn', text: '初回保存日' },
    { value: 'lastUpdatedOn', text: '最終更新日' },
  ];

  public created() {
    // 検索条件を設定する
    if(this.auditNo) {
      this.params.auditNo = this.auditNo;
      this.params.state = null;
    }
    if (this.commodity){
      this.params.commodity = this.commodity;
    }    
    if(!this.auditNo && !this.commodity) {
      this.params.holder = this.$api.license.countOnlyOwned ? this.$api.auth.userId : "";
    }
    this.$api.formatter.ensureListLoaded('workflow_masterBase');        
  }

  public async onCreate(obj: Common.SKU) {
    const workflows = this.$api.formatter.getOptions('workflow_masterBase');
    if (workflows.length > 0) obj.workflowId = workflows[0].value;
    if (this.popup && this.commodity) obj.commodity = this.commodity;
    return Promise.resolve(obj);
  }

  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj);
  }

  public workflowRequired(item: Common.Commodity):boolean {
    if(item.state != Common.MasterBaseStatus.NotPosted) return false;
    var workflows = this.$api.formatter.getOptions('workflow_masterBase');
    return workflows.length > 0;
  }

  public isEditable(item: Common.Commodity):boolean {
    return item.state == Common.MasterBaseStatus.NotPosted;
  }

  public isRequiredBarcode(barcodeType: Common.BarcodeTypes){
    return barcodeType > 0;
  }
}
</script>
